// Add a request interceptor
import axios from "axios";

const customAxios = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

customAxios.interceptors.request.use(
  function (config) {
    let token = null;
    if (window !== undefined) {
      token = localStorage.getItem("token")
        ? JSON.parse(localStorage?.getItem("user")).token
        : null;
    }
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
customAxios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    console.log("error", error);

    const status = error.response?.status;
    const data = error.response?.data || {};
    const apiMessage = data.message || data.error;

    const isAuthFailure =
      status === 401 ||
      apiMessage === "Token expired" ||
      apiMessage === "Invalid token" ||
      apiMessage === "Access token required" ||
      apiMessage === "Invalid bearer token";

    if (isAuthFailure) {
      localStorage.clear();
      sessionStorage.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    if (error.response) {
      return Promise.reject(new Error(apiMessage || "Request failed"));
    }

    return Promise.reject(error);
  }
);

export default customAxios;
